import { render, staticRenderFns } from "./ProviderCNATableList.vue?vue&type=template&id=3cd60f66&scoped=true"
import script from "./ProviderCNATableList.vue?vue&type=script&lang=js"
export * from "./ProviderCNATableList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd60f66",
  null
  
)

export default component.exports